"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react").createContext({tbr:{},rbr:{},cbr:{}});exports.default=e;
